"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryCard = void 0;
var _icons = require("@ori-ui/icons");
var _DeliveryInfo = _interopRequireDefault(require("./DeliveryInfo"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Delivery info card displayed for example in OOB order detail.
 * @param props DeliveryCardProps
 * @returns JSX.Element
 */
const DeliveryCard = props => {
  const {
    addressData,
    className,
    courierDescription,
    courierImageUrl,
    deliveryMethodLabel,
    isHomeDelivery,
    label,
    labelHeadingVariant,
    labelHeadingComponent = 'div',
    phone,
    testId,
    workingHours
  } = props;
  const courierImageProps = {
    alt: courierDescription ?? '',
    shouldThrowError: false,
    src: courierImageUrl ?? ''
  };
  const areWorkingHoursVisible = Boolean(!isHomeDelivery && workingHours);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": testId,
    "aria-label": label ?? 'Delivery information',
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      variant: labelHeadingVariant ?? 'h6',
      component: labelHeadingComponent,
      children: label
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DeliveryMethodTag, {
      variant: "tag",
      label: deliveryMethodLabel
    }), addressData.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressRow, {
      fontWeight: index === 0 ? 'bold' : 'normal',
      children: item
    }, item)), isHomeDelivery ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryInfo.default, {
      ...props
    }), !phone && !areWorkingHoursVisible ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AdditionalInfoWrapper, {
      children: [areWorkingHoursVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AdditionalInfoRow, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clock, {
          fontSize: "small"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AdditionalInfoText, {
          children: workingHours
        })]
      }) : null, phone ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AdditionalInfoRow, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Telephone, {
          fontSize: "small"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AdditionalInfoText, {
          children: phone
        })]
      }) : null]
    }), isHomeDelivery ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CourierBoxWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CourierInfoWrapper, {
        children: [courierDescription ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CourierDescription, {
          children: courierDescription
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryInfo.default, {
          ...props
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CourierImage, {
        ...courierImageProps
      })]
    }) : null]
  });
};
exports.DeliveryCard = DeliveryCard;
var _default = exports.default = DeliveryCard;
